// extracted by mini-css-extract-plugin
export default {"nav-wrap":"DashboardNav_nav-wrap__+GJYm","line":"DashboardNav_line__D2L-7","iconWrap":"DashboardNav_iconWrap__x7DOJ"};